export default __webpack_public_path__ + "static/media/manjarabadfort.d3a5ceda.jpg";